import { useEffect, useState } from "react";
import { getTourBlockedDates } from "@/lib/villaApi";

const DAY_MS = 86400000;

/**
 * Liest die global gesperrten Tour-Tage aus dem Backend.
 * Alle Touren teilen sich einen Kalender.
 */
export function useTourBlockedDates(): Set<string> {
  const [dates, setDates] = useState<Set<string>>(new Set());

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const { data } = await getTourBlockedDates();
        if (!active) return;
        setDates(new Set((data ?? []).map((row) => String(row.blocked_date).slice(0, 10))));
      } catch {
        if (active) setDates(new Set());
      }
    };
    load();
    return () => {
      active = false;
    };
  }, []);

  return dates;
}

/** Prüft, ob irgendein Tag zwischen start und end (inklusive) gesperrt ist. */
export function isTourRangeBlocked(
  blocked: Set<string>,
  start: string,
  end: string
): boolean {
  if (!start) return false;
  if (blocked.size === 0) return false;
  const parts = start.split("-").map(Number);
  if (parts.length < 3 || parts.some((n) => !Number.isFinite(n))) return false;
  const startTime = Date.UTC(parts[0], parts[1] - 1, parts[2]);
  const endParts = (end || start).split("-").map(Number);
  const endTime =
    endParts.length === 3 && endParts.every((n) => Number.isFinite(n))
      ? Date.UTC(endParts[0], endParts[1] - 1, endParts[2])
      : startTime;
  if (endTime < startTime) return false;

  for (let t = startTime; t <= endTime; t += DAY_MS) {
    const d = new Date(t);
    const iso = `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}-${String(
      d.getUTCDate()
    ).padStart(2, "0")}`;
    if (blocked.has(iso)) return true;
  }
  return false;
}